import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import arrayIsNotEmpty from '../utility/arrayIsNotEmpty'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetData } from '../selectors/dataSelector'
import { makeGetDomain } from '../selectors/chartDomainSelector'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import BrushZoomChart from './BrushZoomChart'
import Rainbow from 'rainbowvis.js'

const gradient = new Rainbow()
// gradient.setSpectrum('blue', 'cyan', 'yellow', 'red')
gradient.setSpectrum('#FFFFFF', '#82D2FF', '#FFE878', '#B60015')
const id = 'WaterTemperature'

const chartStyles = datetime => ({
  bar: {
    data: {
      strokeWidth: 3,
      strokeOpacity: 1,
      // fill: d => (d.value < 5 ? GREEN : d.value < 15 ? YELLOW : RED)
      fill: d => `#${gradient.colourAt(d.value / 34 * 100)}`
    }
  }
})

class WaterTemperatureBarChart extends PureComponent {
  render () {
    const { data, datetime, domain, render } = this.props
    const title = 'River temperature'

    if (!arrayIsNotEmpty(data) || !render) {
      return null
    }

    return (
      <BrushZoomChart
        data={data}
        title={title}
        chartStyles={chartStyles}
        datetime={datetime}
        domain={domain}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getData = makeGetData()
  const getDomain = makeGetDomain()
  const getLayerRendered = makeGetLayerRendered()

  const mapStateToProps = state => {
    const data = getData(state, id, getFeaturesFromGeoJson)
    const datetime = getDatetime(state, id)

    return {
      data,
      datetime,
      domain: getDomain(state, data, datetime),
      fetching: state.data.fetching,
      render: getLayerRendered(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {}
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  WaterTemperatureBarChart
)



// WEBPACK FOOTER //
// ./src/charts/WaterTemperatureBarChart.js